import * as React from 'react';
import './PreLoginLayout.scss';

import Announcer from './Announcer';
import NotificationCenter from './NotificationCenter';
import ErrorModalHost from '~/components/ErrorModalHost';
import { IPanelAppContext } from '~/lib/AppContext';

type AppProps = {
    children?: React.ReactNode;
    appContext: IPanelAppContext;
};

export default class PreLoginLayout extends React.Component<AppProps> {
    render() {
        return (
            <div id="root">
                <a href="#main-content" className="skipToContent">
                    Skip to content
                </a>
                <Announcer />
                <NotificationCenter />
                <ErrorModalHost />
                <div className="preLoginLayout d-flex flex-row h-100">
                    <main id="main-content" className="px-2 px-md-4">
                        {this.props.children}
                    </main>
                </div>
            </div>
        );
    }
}
